import { Document, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer'
import React from 'react'
import CertificateFooter from './components/CertificateFooter'
import CertificateName from './components/CertificateName'
import styles from './styles'

export default function AwardCertificatePdf({ salon, customer, participation }: Props) {
    const name = `${customer.first_name} ${customer.last_name}`

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.container}>
                    <View style={[{ flexShrink: 0 }, styles.mgb30]}>
                        <Text style={[styles.sm]}>{salon.state.name}</Text>
                        <View style={[styles.hr]} />
                    </View>
                    <View style={[{ flexShrink: 0 }, styles.mgb30]}>
                        <Text style={[styles.p, { marginBottom: '-5px'}]}><Text style={styles.bold}>{participation.award}</Text> is awarded to</Text>
                        <CertificateName name={name} />
                    </View>
                    <View style={[ownStyles.imageContainer, styles.mgb15]}>
                        <Image 
                            style={[ownStyles.image, styles.mgb10, styles.sm]}
                            src={{ uri: participation.photo.url, body: '', headers: {}, method: 'GET' }} />
                        <Text style={[styles.bold, styles.p]}>{participation.photo.title}</Text>
                    </View>
                    <CertificateFooter salon={salon} />
                </View>
            </Page>
        </Document>
    )
}

interface Props {
    salon: Customer.Models.Salon.Stateful
    participation: Customer.Resources.PastParticipation
    customer: Resources.Customer
}

const ownStyles = StyleSheet.create({
    imageContainer: {
        flexDirection: 'column',
        alignItems: 'flex-start'
    }, 
    image: { 
        height: 'auto', 
        width: 'auto', 
        maxHeight: '100%', 
        maxWidth: '100%', 
        objectFit: 'contain' ,
        borderRadius: '5px'
    }
})